// src/data/reducers/Patient/patient.reducer.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_page: 1,
  page_size: 10,
  has_more: false,
  total_page: 0,
  total_count: 0,
  data: [],
  filters: {},
};

export const PatientSlice = createSlice({
  name: "PatientReducer",
  initialState,
  reducers: {
    setPatientList: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setPatientList } = PatientSlice.actions;
export default PatientSlice.reducer;
